function getOpt (dataArr) {

 let currentMonth = new Date().getMonth();
 dataArr[currentMonth] = {
  value: dataArr[currentMonth],
  itemStyle: {
   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
    offset: 0,
    color: '#F0B58E'
   },
   {
    offset: 1,
    color: '#FFDAB7'
   }
   ], false)
  }
 };
 return {
  tooltip: {
   show: true,
   trigger: 'axis',
   backgroundColor: 'rgba(4, 21, 39, 1)',
   borderWidth: 0,
   textStyle: {
    color: '#fff'
   }
  },
  xAxis: {
   type: 'category',
   axisLabel: {
    color: '#9FBAFD',
    fontSize: 12,//bar字体设置
    interval: 0
   },
   splitLine: {
    show: false
   },
   axisLine: {
    lineStyle: {
     color: "#093E95",
     width: 1
    }
   },
   axisTick: {
    show: false
   },
   data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
  },
  yAxis: {
   type: 'value',
   axisLine: {
    show: true,
    lineStyle: {
     color: "#093E95"
    }
   },
   splitLine: {
    show: false
   },
   axisLabel: {
    color: '#fff',
    fontSize: 12//bar字体设置
   },
  },
  grid: {
   left: "8%",
   top: "15%",
   width: 500,
   height: 120
  },
  series: [
   {
    data: dataArr,
    barWidth: 20,//柱图宽度
    type: 'bar',
    itemStyle: {
     barBorderRadius: [2, 2, 0, 0],
     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: '#7F96EA '
     },
     {
      offset: 1,
      color: '#77B1EC'
     }
     ], false)
    },
   }
  ]
 }
};

export default getOpt